import useTranslation from 'next-translate/useTranslation';
import { Flex, Text } from '@eqi-investimentos/react';
import { Drawer } from '@/components/molecules/Drawer';
import { PERSONAL_INFO_DRAWER_ID } from './utils';
import { useGetAccount } from '../../http/client/useGetAccount';
import { CONFIRM_DELETE_ACCOUNT_ID, ConfirmDeleteAccountDrawer } from './ConfirmDeleteAccountDrawer';
import { EditPasswordButton } from './Edit/PasswordButton';
import { EditPasswordDrawer } from './Edit/PasswordDrawer';
import { EditProfileInfoDrawer } from './Edit/ProfileInfoDrawer';
import { EditProfileInfoInput } from './Edit/ProfileInfoInput';
import { ProfileItem } from './Item';
export const PersonalInfoDrawer = () => {
  const {
    t
  } = useTranslation('common');
  const {
    data
  } = useGetAccount();
  return <>
      <Drawer id={PERSONAL_INFO_DRAWER_ID} headerContent={<Text size="xl" color="content.primary">
            {t('drawers.personalInfo.header')}
          </Text>} closeButtonProps={{
      top: '3.125rem'
    }} headerProps={{
      pl: '3.4375rem',
      pr: '3rem',
      py: '2.8125rem'
    }} data-sentry-element="Drawer" data-sentry-source-file="PersonalInfo.tsx">
        <Flex flexDir="column" justifyContent="space-between" gap="32" h="full" pb="9" data-sentry-element="Flex" data-sentry-source-file="PersonalInfo.tsx">
          <Flex flexDir="column" gap="5" data-sentry-element="Flex" data-sentry-source-file="PersonalInfo.tsx">
            <EditProfileInfoInput value={data?.name ?? ''} type="name" data-sentry-element="EditProfileInfoInput" data-sentry-source-file="PersonalInfo.tsx" />
            <EditProfileInfoInput value={data?.email ?? ''} type="email" data-sentry-element="EditProfileInfoInput" data-sentry-source-file="PersonalInfo.tsx" />
            <EditProfileInfoInput value={data?.phone ?? ''} type="phone" data-sentry-element="EditProfileInfoInput" data-sentry-source-file="PersonalInfo.tsx" />
            <EditPasswordButton data-sentry-element="EditPasswordButton" data-sentry-source-file="PersonalInfo.tsx" />
          </Flex>
          <ProfileItem title={t('drawers.profile.ctaDeleteAccount')} leftIcon="PersonOff" type="action" onClick={() => window.dispatchEvent(new CustomEvent(`open-chakra-modal-${CONFIRM_DELETE_ACCOUNT_ID}`))} showArrow={false} py="0" data-sentry-element="ProfileItem" data-sentry-source-file="PersonalInfo.tsx" />
        </Flex>
        <ConfirmDeleteAccountDrawer data-sentry-element="ConfirmDeleteAccountDrawer" data-sentry-source-file="PersonalInfo.tsx" />
      </Drawer>
      <EditProfileInfoDrawer currentValue={data?.name ?? ''} type="name" data-sentry-element="EditProfileInfoDrawer" data-sentry-source-file="PersonalInfo.tsx" />
      <EditProfileInfoDrawer currentValue={data?.email ?? ''} type="email" data-sentry-element="EditProfileInfoDrawer" data-sentry-source-file="PersonalInfo.tsx" />
      <EditProfileInfoDrawer currentValue={data?.phone ?? ''} type="phone" data-sentry-element="EditProfileInfoDrawer" data-sentry-source-file="PersonalInfo.tsx" />
      <EditPasswordDrawer data-sentry-element="EditPasswordDrawer" data-sentry-source-file="PersonalInfo.tsx" />
    </>;
};